// Module
var code = "<span ng-if=\"doShowNewDashboard()\" ng-include=\"'views/dashboard-new.html'\"></span> <span ng-if=\"!doShowNewDashboard()\" ng-include=\"'views/dashboard-old.html'\"></span>";
// Exports
var _module_exports =code;;
var path = '/views/dashboard-switch.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;